import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { catchError, map, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CreateUserRequest, UpdateUserRequest, UserResponse } from '../Shared/Models/User.model';

@Injectable({ providedIn: 'root' })
export class UserService {
  constructor(private http: HttpClient) { }


  getAllUsers(): Observable<UserResponse[]> {
    return this.http.get<UserResponse[]>(`${environment.backendUrl}/Users/GetAllUsers`);
  }
  getUser(userId: number): Observable<UserResponse> {
    return this.http.get<UserResponse>(`${environment.backendUrl}/Users/GetUserDetail/${userId}`);
  }
  createUser(userData: CreateUserRequest): Observable<any> {
    return this.http.post(`${environment.backendUrl}/Users/CreateUser`, userData);
  }
  updateUser(userId: number, userData: UpdateUserRequest): Observable<any> {
    return this.http.put(`${environment.backendUrl}/Users/UpdateUser/${userId}`, userData);
  }
  deleteUser(userId: number): Observable<any> {
    return this.http.delete(`${environment.backendUrl}/Users/DeleteUser/${userId}`);
  }
  activateUser(userId: number): Observable<any> {
    return this.http.post(`${environment.backendUrl}/Users/ActivateUser/${userId}/activate`, {});
  }
  deactivateUser(userId: number): Observable<any> {
    return this.http.post(`${environment.backendUrl}/Users/DeactivateUser/${userId}/deactivate`, {});
  }
  resetMFA(userId: number): Observable<any> {
    return this.http.post(`${environment.backendUrl}/Users/ResetMFA/${userId}`, {});
  }
  resetPassword(userId: number, newPassword: string): Observable<any> {
    return this.http.post(`${environment.backendUrl}/Users/ResetPassword/${userId}`, { newPassword });
  }
  getRoles(): Observable<any[]> {
    return this.http.get<any[]>(`${environment.backendUrl}/Users/GetAllRoles`);
  }

}
